export default __webpack_public_path__ + "static/media/OUTSTANDINGPAYMENT_SAVE2.c58a26d7.png";